<script>
  import { inertia, router } from "@inertiajs/svelte";
  import Dollar from "../../Components/Dollar.svelte";
  import { page } from "@inertiajs/svelte";
</script>

{#if Object.keys($page.props.cart).length > 0}
  <div
    class="d-flex justify-content-between p-2 text-muted text-center bg-light-subtle border border-bottom-0"
  >
    <div class="fs-5">Your Shopping Cart</div>
    <a
      use:inertia
      href={window.route("renewal.cart")}
      class="btn btn-sm btn-outline-primary"
      ><i class="bi bi-cart"></i> View Cart</a
    >
  </div>
  <ul class="list-group">
    {#each Object.entries($page.props.cart) as [id, item]}
      <li class="list-group-item rounded-top-0">
        <div class="mx-2">
          <div class="d-flex w-100 justify-content-between">
            <div class="fw-bold">
              {item.vehicle}
            </div>
            <div>
              <Dollar value={item.total} />
            </div>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <div>
              {item.renewal.renewalTerm} Year Renewal
            </div>
            <div>
              <div
                class="btn-group btn-group-sm"
                role="group"
                aria-label="Small button group"
              >
                <a
                  use:inertia={{ data: { id: id } }}
                  href={window.route("renewal.detail")}
                  class="link-primary small opacity-75 link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                  >Edit</a
                >
                <span class="small"> &nbsp;|&nbsp; </span>
                <button
                  type="button"
                  on:click|once={() =>
                    router.delete(window.route("renewal.cart.delete"), {
                      data: { id: id },
                    })}
                  class="btn btn-link p-0 link-danger small opacity-75 link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
                  >Remove</button
                >
              </div>
            </div>
          </div>
        </div>
      </li>
    {/each}
  </ul>
  <br />
{/if}
